import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import UserList from './users/UserList';
import UserForm from './users/UserForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addUsersAction } from '../../actions/usersActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Users = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addUsersAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Usuarios' 
                subtitle='Administración' 
                nodes={nodes}
                actions={actions}
                component={UserList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <UserForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Users;